import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { ManagementReservationSearchRequest } from "@/components/features/management";

import { useConfirmParams } from "./hooks";

export const ManagementReservationRequestListPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="予約の管理" url={generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.REQUEST_LIST, { hotelID })}>
			<ManagementReservationSearchRequest hotelID={hotelID} />
		</PageMeta>
	);
};
